import * as $runtime from "../runtime.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Restaumatic$dLocales from "../Restaumatic.Locales/index.js";
import * as Unscramble from "../Unscramble/index.js";
const Translated = x => x;
const Localized = x => x;
const udecodeTranslated = dictDecode => Unscramble.decodeMap(Restaumatic$dLocales.ufromJSONKeyLocale)(Restaumatic$dLocales.ordLocale)(dictDecode);
const showTranslated = dictShow => Data$dMap$dInternal.showMap(Restaumatic$dLocales.showLocale)(dictShow);
const ordTranslated = dictOrd => Data$dMap$dInternal.ordMap(Restaumatic$dLocales.ordLocale)(dictOrd);
const newtypeTranslated = {Coercible0: () => {}};
const singletonTranslated = locale => value => Data$dMap$dInternal.$$$Map("Two", Data$dMap$dInternal.Leaf, locale, value, Data$dMap$dInternal.Leaf);
const eqTranslated = dictEq => Data$dMap$dInternal.eqMap(Restaumatic$dLocales.eqLocale)(dictEq);
const encodeTranslated = dictEncode => (
  {
    encode: (() => {
      const $0 = Data$dFunctor.arrayMap(v => Data$dTuple.$Tuple(
        (() => {
          if (v._1.tag === "PL") { return "pl"; }
          if (v._1.tag === "EN") { return "en"; }
          if (v._1.tag === "EN_GB") { return "en-GB"; }
          if (v._1.tag === "RO") { return "ro"; }
          if (v._1.tag === "RU") { return "ru"; }
          if (v._1.tag === "CS") { return "cs"; }
          if (v._1.tag === "SK") { return "sk"; }
          if (v._1.tag === "HR") { return "hr"; }
          if (v._1.tag === "DE") { return "de"; }
          if (v._1.tag === "NL") { return "nl"; }
          if (v._1.tag === "ES") { return "es"; }
          if (v._1.tag === "IT") { return "it"; }
          if (v._1.tag === "UK") { return "uk"; }
          if (v._1.tag === "PT_BR") { return "pt-BR"; }
          $runtime.fail();
        })(),
        v._2
      ));
      return x => Foreign$dObject._mapWithKey(
        Foreign$dObject.fromFoldable(Data$dFoldable.foldableArray)($0(Data$dMap$dInternal.toUnfoldable(Data$dUnfoldable.unfoldableArray)(x))),
        v => dictEncode.encode
      );
    })()
  }
);
const emptyTranslated = Data$dMap$dInternal.Leaf;
const getLocalization = locale => v => {
  const $0 = Data$dMap$dInternal.lookup(Restaumatic$dLocales.ordLocale)(locale)(v);
  const $1 = Data$dMap$dInternal.lookup(Restaumatic$dLocales.ordLocale)(Restaumatic$dLocales.PL)(v);
  if ($0.tag === "Nothing") {
    if ($1.tag === "Nothing") { return ""; }
    if ($1.tag === "Just") { return $1._1; }
    $runtime.fail();
  }
  if ($0.tag === "Nothing") { return ""; }
  if ($0.tag === "Just") { return $0._1; }
  $runtime.fail();
};
const decodeTranslated = dictDecode => (
  {
    decode: f => {
      const mapFromArray = Data$dMap$dInternal.fromFoldable(Restaumatic$dLocales.ordLocale)(Data$dFoldable.foldableArray);
      return Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind((() => {
        const $0 = Foreign$dObject.toArrayWithKey(Data$dTuple.Tuple);
        const $1 = Foreign$dGeneric$dClass.objectDecode(dictDecode).decode(f);
        if ($1.tag === "Left") { return Data$dEither.$Either("Left", $1._1); }
        if ($1.tag === "Right") { return Data$dEither.$Either("Right", Data$dArray.toUnfoldable(Data$dUnfoldable.unfoldableArray)($0($1._1))); }
        $runtime.fail();
      })())(v => Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind(Data$dTraversable.traversableArray.traverse(Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity))(v$1 => Control$dMonad$dExcept$dTrans.applyExceptT(Data$dIdentity.monadIdentity).apply((() => {
        const $0 = Restaumatic$dLocales.decodeLocale.decode(v$1._1);
        if ($0.tag === "Left") { return Data$dEither.$Either("Left", $0._1); }
        if ($0.tag === "Right") { return Data$dEither.$Either("Right", Data$dTuple.Tuple($0._1)); }
        $runtime.fail();
      })())(Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure(v$1._2)))(v))(v1 => Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure(mapFromArray(v1))));
    }
  }
);
export {
  Localized,
  Translated,
  decodeTranslated,
  emptyTranslated,
  encodeTranslated,
  eqTranslated,
  getLocalization,
  newtypeTranslated,
  ordTranslated,
  showTranslated,
  singletonTranslated,
  udecodeTranslated
};
